import { useEffect, useState, type RefObject } from "react";

/** True when the container is below `breakpointPx` — plan/34 container width. */
export function useContainerNarrow(
  ref: RefObject<HTMLElement | null>,
  breakpointPx = 720,
): boolean {
  const [narrow, setNarrow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect.width ?? el.clientWidth;
      setNarrow(w < breakpointPx);
    });
    ro.observe(el);
    setNarrow(el.clientWidth < breakpointPx);
    return () => ro.disconnect();
  }, [ref, breakpointPx]);

  return narrow;
}
